import React from 'react';
import { useDispatch } from 'react-redux';
import { actionPopupDidScrollPage } from '../redux/actions';
import {
  getScrolledVerticalOffset,
  getVerticalScrollRange,
  getScrollArea,
  isParentWindowInMeeting,
  getParentWindowMeetingRole
} from '../utils/window';
import { debounce } from 'lodash';
import { MeetingRole } from '../interfaces';
import { isEmbeddedInStreamingStudio } from '../utils/streamingstudio';

const PageScrollListener = (props: { children: React.ReactNode }) => {
  const dispatch = useDispatch();

  const debouncedScrollListener = debounce(() => {
    const scrolledOffset = getScrolledVerticalOffset();
    console.log(`scrolled pixel ${scrolledOffset}`);
    const totalYScrollRange = getVerticalScrollRange();
    const scrolledRange =
      totalYScrollRange > 0 ? scrolledOffset / totalYScrollRange : 0;
    dispatch(actionPopupDidScrollPage(scrolledRange));
  }, 200);

  React.useEffect(() => {
    const inMeeting = isParentWindowInMeeting();
    const isPresenter = getParentWindowMeetingRole() === MeetingRole.ADVISOR;
    const isEmbeddedInSsp = isEmbeddedInStreamingStudio();
    if ((inMeeting && isPresenter) || isEmbeddedInSsp) {
      getScrollArea()?.addEventListener('scroll', debouncedScrollListener);
    }
    return () => {
      getScrollArea()?.removeEventListener('scroll', debouncedScrollListener);
    };
  }, []);

  return <>{props.children}</>;
};

export default PageScrollListener;
